export const it = {
  nav: { home: "Home", pricing: "Prezzi", demo: "Demo", signin: "Accedi con LinkedIn", signout: "Esci" },
  hero: { title: "Aumenta la portata LinkedIn con pod privati e invisibili", subtitle: "Ti abbiniamo a pod esistenti su invito dietro le quinte. Niente automazione. Rotazione equa, limiti giornalieri e punti per engagement di qualità." },
  cta: { pricing: "Vedi prezzi", demo: "Guarda la demo" },
  features: {
    invite: { title: "Qualità su invito", desc: "Matching invisibile a pod curati." },
    fair: { title: "Equo e conforme", desc: "Clic manuale verso LinkedIn. Mai bot." },
    points: { title: "Punti e limiti", desc: "2 invii/giorno. Like=1, Commento=3." }
  },
  how: { title: "Come funziona", step1: "1. Richiedi accesso e onboarding.", step2: "2. Ti assegniamo automaticamente a pod esistenti.", step3: "3. Condividi, interagisci manualmente, guadagna punti, aumenta la reach." },
  compliance: { title: "Conformità", copy: "Mai automazione di like/commenti. Gli utenti cliccano sempre su LinkedIn. Matching e rotazione lato server nel rispetto dei TOS." },
  faq: {
    title: "FAQ",
    platforms_q: "Quali piattaforme?",
    platforms_a: "Solo LinkedIn per v1.",
    submissions_q: "Quanti invii?",
    submissions_a: "Fino a 2 invii attivi al giorno.",
    points_q: "Come vengono calcolati i punti?",
    points_a: "Like = 1 punto, Commento = 3 punti. È richiesto un minimo per inviare."
  },
  pricing: {
    title: "Prezzi semplici",
    subtitle: "Scegli un piano e richiedi l'accesso. Disdici quando vuoi.",
    starter: "Starter",
    pro: "Pro",
    team: "Team",
    price_starter: "19€/mese",
    price_pro: "49€/mese",
    price_team: "Contattaci",
    feat_curated: "Pod curati",
    feat_priority: "Matching prioritario",
    feat_analytics_basic: "Analisi di base",
    feat_analytics_adv: "Analisi avanzate",
    feat_seats: "Postazioni multiple",
    feat_limits: "Limiti personalizzati",
    feat_sla: "Supporto SLA",
    cta: "Richiedi accesso"
  },
  demo: {
    title: "Demo (solo lettura)",
    subtitle: "Illustrazione del flusso di engagement manuale e del sistema di punti.",
    queue_title: "Coda di engagement",
    points_title: "Anteprima punti",
    open: "Apri"
  },
  footer: { copy: "© EngagePods. v1 solo LinkedIn. Pod su invito." }
} as const;
